import { Container } from '@/components/layout/container';
import { Skeleton } from '@/components/ui/skeleton';

export const BlogLoadingSkeleton = () => {
	return (
		<Container className="relative z-10 flex flex-col items-center justify-between">
			<div className="relative z-20 w-full text-center">
				<Skeleton className="mx-auto mt-4 h-12 w-3/4 max-w-xl" />
				<Skeleton className="mx-auto mt-4 h-6 w-2/3 max-w-lg" />
			</div>

			<div className="mx-auto mt-12 w-full max-w-5xl">
				<div className="overflow-hidden rounded-lg">
					<Skeleton className="aspect-[16/9] h-[400px] w-full" />
					<div className="space-y-3 p-4">
						<Skeleton className="h-4 w-32" />
						<Skeleton className="h-6 w-full" />
						<Skeleton className="h-4 w-3/4" />
					</div>
				</div>
			</div>

			<Skeleton className="mb-12 mt-12 h-8 w-64" />

			<div className="grid w-full gap-8 md:grid-cols-2 lg:grid-cols-3">
				{Array.from({ length: 6 }).map((_, idx) => (
					<div key={idx} className="overflow-hidden rounded-lg">
						<Skeleton className="aspect-[16/9] h-[200px] w-full" />
						<div className="space-y-3 p-4">
							<Skeleton className="h-4 w-32" />
							<Skeleton className="h-6 w-full" />
							<Skeleton className="h-4 w-3/4" />
						</div>
					</div>
				))}
			</div>

			<div className="mt-12 flex justify-center gap-2">
				{Array.from({ length: 5 }).map((_, idx) => (
					<Skeleton key={idx} className="h-10 w-10 rounded-md" />
				))}
			</div>
		</Container>
	);
};
